export interface SocialMedia {
  userId: string;
  identifier: SocialMediaIdentifier;
  accountId: string;
  username: string;
  icon: React.ReactNode;
}

export enum SocialMediaIdentifier {
  FACEBOOK = "FACEBOOK",
  LINKEDIN = "LINKEDIN",
  X = "X",
  WHATSAPP = "WHATSAPP",
  //GOOGLE_MY_BUSINESS = "GOOGLE_MY_BUSINESS",
  INSTAGRAM = "INSTAGRAM",
  TIKTOK = "TIKTOK",
  EMAIL = "EMAIL",
}
export interface PostType {
  type: "Regular" | "Reel" | "Story";
}

export interface Channel {
  identifier: SocialMediaIdentifier;
  icon: React.ReactNode;
  enabled: boolean;
}

export interface Post {
  id: string;
  platform: SocialMediaIdentifier;
  content: string;
  image?: File[];
  status: "draft" | "scheduled" | "published";
  datetimeScheduled: Date;
}
